import { AngleProcessingAvailability } from 'cloud-shared-lib';
import { AngleMode } from '../models/cutting/cutting-panel-outline.model';

export class AngleSettingsHelper {
  static getAngleMods(angleProcessingAvailability: AngleProcessingAvailability): Set<AngleMode> {
    const mods = Object.values(AngleMode)
      .filter(value => typeof value === 'number')
      .map(value => value as AngleMode);

    const modsSet = new Set(mods);

    if (!angleProcessingAvailability.rounding) {
      modsSet.delete(AngleMode.Rounded);
    }

    if (!angleProcessingAvailability.insideRounding) {
      modsSet.delete(AngleMode.RoundedInside);
    }

    if (!angleProcessingAvailability.chamfer) {
      modsSet.delete(AngleMode.Chamfer);
    }

    if (!angleProcessingAvailability.cutting) {
      modsSet.delete(AngleMode.Cutted);
    }

    if (!angleProcessingAvailability.diagonalCutting) {
      modsSet.delete(AngleMode.DiagonalCut);
    }

    if (!angleProcessingAvailability.insideCutting) {
      modsSet.delete(AngleMode.CuttedInside);
    }

    if (!angleProcessingAvailability.masonsMitre) {
      modsSet.delete(AngleMode.MasonsMitreFemale);
      modsSet.delete(AngleMode.MasonsMitreMale);
    }

    if (!angleProcessingAvailability.insideCuttingWithAngle) {
      modsSet.delete(AngleMode.CuttedInsideWithAngle);
    }

    return modsSet;
  }
}
